<template>
  <div class="mt-3">
    <b-button-group class="w-100" :size="$mq === 'sm' ? 'small' : ''" :vertical="$mq === 'sm'">
      <b-button variant="warning" @click="$router.push({ name: 'Dashboard'})">
        <i class="fa fa-home" />
        Dashboard
      </b-button>
      <b-button variant="warning" v-if="$hasRole(serviceModule, 'Admin')" @click="$router.push({ name: 'VehicleRecord'})">
        <i class="fa fa-car" />
        Vehicle Records
      </b-button>
      <b-button variant="warning" @click="$router.push({ name: 'VehicleList'})">
        <i class="fa fa-list" />
        Vehicle List
      </b-button>
      <b-button variant="warning" v-if="$hasRole(serviceModule, 'Admin')" @click="$router.push({ name: 'Workshop'})">
        <i class="fa fa-list" />
        Workshops
      </b-button>
      <b-button variant="warning" v-if="$hasRole(serviceModule, 'Admin')" @click="$router.push({ name: 'ElectricVehicles'})">
        <i class="fa fa-gear" />
        Electric Vehicles
      </b-button>
      <b-button variant="warning" v-if="$hasRole(serviceModule, 'Admin')" @click="$router.push({ name: 'ElectricVehiclesConfig'})">
        <i class="fa fa-gear" />
        Electric Vehicles Config
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: 'NavigationFooter',
  data() {
    return {
      serviceModule: process.env.VUE_APP_MODE === 'production' ? 'CCPL - VMTS v2' : 'OPS - VMTS REVAMP',
    }
  }
}
</script>

<style lang="scss" scoped>

</style>